
const currentLang = window.currentLang ?? document.documentElement.lang

localStorage.setItem('lang', currentLang)

if(currentLang === 'ar-sa') {
    arabicVersion()
} else {
    englishVersion()
}

// $('.js-change-lang li').on('click', e => {
//     let activeLang = $('.js-change-lang li p')
//     $(activeLang).hasClass('lang__link--active') && $(activeLang).removeClass('lang__link--active')
//     $(e.target).toggleClass('lang__link--active')
//     if ($(e.target).html().trim() === 'Ar') {
//         const lang = 'ar-sa'
//
//         $('html').attr('dir', 'rtl')
//         $('html').attr('lang', lang)
//         $link = $('<link/>', {
//             rel: 'stylesheet',
//             href: '/assets/css/front/rtl.css?v='
//         }).appendTo('head');
//         arabicVersion()
//         localStorage.setItem('lang', lang)
//     } else {
//         const lang = 'en'
//
//         $('.js-change-text-home').html('Home')
//         englishVersion()
//
//         $('html').removeAttr('dir')
//         $('html').attr('lang', lang)
//         localStorage.setItem('lang', lang)
//     }
// })

function setLangInSession()
{

}

function getLangInSession()
{

}

function arabicVersion() {
    // forgot password
    $('.js-change-text-forgot-password-header').html('إعادة تعيين كلمة المرور')
    $('.js-change-text-forgot-password-body-text').html('نسيت كلمة المرور ؟ الرجاء ادخال البريد الالكتروني أدناه وسوف يصلك رابط لإعادة تعيين كلمة المرور الخاصة بك على بريدك المسجل')
    $('.js-change-text-btn-forgot-password').html('إرسال الرابط')
    $('.js-login-forgot-password-status').html('لقد أرسلنا رابط إعادة تعيين كلمة المرور عبر البريد الإلكتروني!')
    $('.js-login-success-reset-pass-status').html('تمت إعادة تعيين كلمة المرور الخاصة بك!')

    // verify-email
    $('.js-verify-email-status').html('تم إرسال رابط تحقق جديد إلى عنوان بريدك الإلكتروني.')
    $('.js-verify-email-text-1').html('قبل المتابعة، يرجى التحقق من بريدك الإلكتروني والضغط  على رابط التحقق المرسل إلى البريد الإلكتروني:')

    $('.js-verify-email-submit-email').html('إعادة إرسال الرابط')

    $('.js-change-text-home').html('الرئيسية')
    $('.js-change-text-dropdown-3d-print').html('الخدمات')
    $('.js-change-text-client-model').html('طباعة النماذج ثلاثية الأبعاد')
    $('.js-change-text-gallery').html('معرض النماذج والمنتجات')
    $('.js-change-text-users-models').html('معرض النماذج والمنتجات')
    $('.js-change-text-dropdown-resources').html('المصادر والمعلومات')
    $('.js-change-text-technology').html('تقنيات الطباعة ثلاثية الأبعاد')
    $('.js-change-text-faq').html('الأسئلة الشائعة')
    $('.js-change-text-privacy').html(' سياسة الخصوصية')
    $('.js-change-text-contact').html('تواصل معنا')
    $('.js-change-text-dropdown-menu').html('القائمة')
    $('.js-change-text-login').html('تسجيل الدخول')
    $('.js-change-text-login-header').html('تسجيل الدخول إلى حسابك')
    $('.js-change-text-login-propose').html('هل لديك حساب؟')
    $('.js-change-text-login-btn').html('تسجيل الدخول')
    $('.js-change-text-register-header').html('تسجيل حساب جديد')
    $('.js-change-text-register').html('اشتراك')
    $('.js-change-text-register-propose').html('ليس لديك حساب؟ ')
    $('.js-change-text-email').html('البريد الإلكتروني')
    $('.js-change-text-password').html('كلمة المرور')
    $('.js-change-text-remember').html('تذكرني')
    $('.js-change-text-forget').html('نسيت كلمة المرور؟')
    $('.js-change-text-first-name').html('الاسم الأول')
    $('.js-change-text-last-name').html('اسم العائلة')
    $('.js-change-text-confirm-password').html('تأكيد كلمة المرور')
    $('.js-change-text-cart-name').html('السلة')
    $('.js-change-text-cart-model').html('طلباتي')
    $('.js-change-text-total-price').html('السعر الكلي')
    $('.js-change-text-brood-price').html('السعرالاجمالي')
    $('.js-change-text-discount').html('الخصم')
    $('.js-change-text-offer').html('العروض')
    $('.js-change-text-shipping').html('الشحن')
    $('.js-change-text-address').html('العنوان')
    $('.js-change-text-have-promo-code').html('كود الخصم')
    $('.js-change-text-check-promo-code').html('اضف كود الخصم')
    $('.js-change-text-placeholder-promo-code').attr("placeholder", "كود الخصم");
    $('.js-change-text-check-phone').html('هاتف')
    $('.js-change-text-header-user-name').html('ملف المستخدم')
    $('.js-change-text-header-home').html('الرئيسية')
    $('.js-change-text-header-reset-password').html('إعادة تعيين كلمة المرور')
    $('.js-change-text-header-reset-password-link').html('إرسال رابط إعادة تعيين كلمة المرور')
    $('.js-change-text-title').html('العنوان')
    $('.js-change-text-country').html('الدولة')
    $('.js-change-text-update').html('تحديث')
    $('.js-change-text-password-confirm').html('تأكيد كلمة المرور')
    $('.js-change-text-addresses').html('العناوين')
    $('.js-change-text-create-address').html('إضافة عنوان جديد')
    $('.js-change-text-create-address-here').html('قم بإضافة عنوانك الأول هنا')
    $('.js-change-text-not-address').html('ليس لديك أي عنوان حتى الآن.')
    $('.js-change-text-number').html('الرمز البريدي')
    $('.js-change-text-street').html('الشارع')
    $('.js-change-text-city').html('المدينة')
    $('.js-change-text-orders').html('طلبات')
    $('.js-change-text-wishlist').html('قائمة الرغبات')
    $('.js-change-text-logout').html('تسجيل الخروج')
    $('.js-change-text-term').html(' شروط الاستخدام')
    $('.js-change-text-create-order').html('إنشاء النظام')
    $('.js-change-text-pay').html('يدفع')
    $('.js-change-text-create').html('يخلق')
    $('.js-change-text-header-personal-info').html('معلوماتي')
    $('.js-change-text-subheader-personal-info').html('اكتب معلومات عامة عن نفسك')
    $('.js-update-user-info').html('تحديث')
    $('.js-change-text-add-address').html('اضف العنوان')
    $('.js-change-text-header-addresses').html('عناوين التوصيل')
    $('.js-change-text-subheader-addresses').html('أضف العناوين المناسبة للتسليم' +
        'المنتجات')


}

function englishVersion() {
    // forgot password
    $('.js-change-text-forgot-password-header').html('Reset Password')
    $('.js-change-text-forgot-password-body-text').html('Forgot your password? No problem. Just let us know your email address and we will email you a password reset link that will allow you to choose a new one.')
    $('.js-change-text-btn-forgot-password').html('Send Link')
    $('.js-login-forgot-password-status').html('We have emailed your password reset link!')
    $('.js-login-success-reset-pass-status').html('Your password has been reset!')

    // verify-email
    $('.js-verify-email-status').html('A fresh verification link has been sent to your email address.')
    $('.js-verify-email-text-1').html('Before proceeding, please check your email for a verification link. We sent you a message to this email:')

    $('.js-verify-email-submit-email').html('Resend Link')

    $('.js-change-text-create').html('Create')
    $('.js-change-text-create-order').html('Create Order')
    $('.js-change-text-pay').html('Pay')
    $('.js-change-text-term').html('Term of Service')
    $('.js-change-text-logout').html('Logout')
    $('.js-change-text-orders').html('Orders')
    $('.js-change-text-wishlist').html('Wishlist')
    $('.js-change-text-city').html('City')
    $('.js-change-text-street').html('Street')
    $('.js-change-text-number').html('Postal Code')
    $('.js-change-text-not-address').html('You don\'t have any address yet.')
    $('.js-change-text-addresses').html('Addresses')
    $('.js-change-text-create-address').html('Create new address')
    $('.js-change-text-create-address-here').html('Create your first address here')

    $('.js-change-text-update').html('Update')
    $('.js-change-text-country').html('Country')
    $('.js-change-text-title').html('Title')
    $('.js-change-text-header-reset-password').html('Reset Password')
    $('.js-change-text-header-reset-password-link').html('Reset Password')

    $('.js-change-text-header-home').html('Home')

    $('.js-change-text-placeholder-promo-code').attr("placeholder", "Promo-code");
    $('.js-change-text-check-promo-code').html('Use Promo code')
    $('.js-change-text-check-phone').html('Phone')
    $('.js-change-text-have-promo-code').html('I have promo-code')
    $('.js-change-text-address').html('Address')
    $('.js-change-text-total-price').html('Total price')
    $('.js-change-text-brood-price').html('Original price')
    $('.js-change-text-discount').html('Discount')
    $('.js-change-text-offer').html('Offer')
    $('.js-change-text-shipping').html('Shipping')
    $('.js-change-text-cart-model').html('Model')
    $('.js-change-text-technology').html('3D Printing Technology')
    $('.js-change-text-home').html('Home')
    $('.js-change-text-dropdown-3d-print').html('3D Services')
    $('.js-change-text-client-model').html('Print your 3D model')
    $('.js-change-text-gallery').html('Gallery')
    $('.js-change-text-users-models').html('Users models')
    $('.js-change-text-dropdown-resources').html('Resources')
    $('.js-change-text-faq').html('FAQ')
    $('.js-change-text-privacy').html('Privacy Policy')
    $('.js-change-text-contact').html('Contact Us')
    $('.js-change-text-dropdown-menu').html('Menu')
    $('.js-change-text-login').html('Sign in')
    $('.js-change-text-login-header').html('Sign in to your account')
    $('.js-change-text-login-propose').html('Already have an account?')
    $('.js-change-text-login-btn').html('Sign In')
    $('.js-change-text-register-header').html('Sign up to your account')
    $('.js-change-text-register').html('Sign Up')
    $('.js-change-text-register-propose').html('Don`t have an account?')
    $('.js-change-text-email').html('Email Address')
    $('.js-change-text-password').html('Password')
    $('.js-change-text-remember').html('Remember me')
    $('.js-change-text-forget').html('Forget your password?')
    $('.js-change-text-first-name').html('First Name')
    $('.js-change-text-last-name').html('Last Name')
    $('.js-change-text-confirm-password').html('Confirm Password')
    $('.js-change-text-password-confirm').html('Password Confirmation')
    $('.js-change-text-cart-name').html('Cart')
    $('.js-change-text-header-user-name').html('User Profile')
    $('.js-change-text-header-personal-info').html('Personal Information')
    $('.js-change-text-subheader-personal-info').html('Write general information about yourself')
    $('.js-change-text-add-address').html('Add Address')
    $('.js-update-user-info').html('Update')


}

function changeTextToArabic() {

    if (localStorage.getItem('lang') === 'ar-sa') {
        arabicVersion()
    } else {
        englishVersion()
    }
}

changeTextToArabic()
